import "./FindJobs.css";
import AllJobsItem from "../allJobsItem/AllJobsItem";
import usePublicDivision from "../../hook/usePublicDivision";

const FindJobs = () => {
  const { divisonList } = usePublicDivision();

  //console.log(divisonList);

  return (
    <div className="findJobs-container" data-aos="zoom-in">
      <h3>
        Search through Healthcare professional <br /> Divisions for Available
        On-demand vacancies near you.
      </h3>

      <div className="scroll-bg">
        <section className="scroll-logo-section">
          <ul className="js_marquee">
            {[...divisonList, ...divisonList].map(({ label, value }, index) => (
              <li key={value + "-" + index}>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <div>
        <AllJobsItem />
      </div>
    </div>
  );
};

export default FindJobs;
